import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { CommentListasyncReqPros, CommentListInitialState } from "../model/CommentListReducerType";

const reducerId = "CommentListReducer/asyncReqCommentList";
const controllerMap = new Map();

const initialState: CommentListInitialState = {
    status: "",
    currPage: 1,
    n4ErrorCode: 0,
    strErrorMessage: "",
    n4CurrCount: 0,
    n4TotalCount: 0,
    n4TotalPage: 0,
    LIST: []
};

const slice = createSlice({
    name: "CommentListReducer",
    initialState,
    reducers: {
        setCurrPage: (state, action) => {
            state.currPage = action.payload;
        },
        addList: (state, action) => {
            if (action.payload.UBC_REF_COMMENT_SEQ === action.payload.UBC_COMMENT_SEQ) {
                state.LIST.push(action.payload);
            }
            else {
                let new_list: typeof state.LIST = [];
                state.LIST.forEach((item) => {
                    new_list.push(item);
                    if (item.UBC_REF_COMMENT_SEQ === action.payload.UBC_REF_COMMENT_SEQ) new_list.push(action.payload);
                });
                state.LIST = new_list;
            }
        },
        removeItem: (state, action) => {
            state.LIST = state.LIST.filter((item) => item.UBC_COMMENT_SEQ !== action.payload);
        }
    },
    extraReducers: (builder) => {
        builder.addCase(asyncReqCommentList.pending, (state) => {
            state.status = "LOADING";
        });
        builder.addCase(asyncReqCommentList.fulfilled, (state, action) => {
            state.status = "COMPLETE";
            state.n4ErrorCode = action.payload.n4ErrorCode;
            state.strErrorMessage = action.payload.strErrorMessage;
            state.n4CurrCount = action.payload.n4CurrCount;
            state.n4TotalCount = action.payload.n4TotalCount;
            state.n4TotalPage = action.payload.n4TotalPage;
            state.LIST = action.payload.LIST;
        });
        builder.addCase(asyncReqCommentList.rejected, (state, action) => {
            if (action.payload?.aborted) return; // 'AbortError'로 인한 취소라면 상태 변경하지 않음
            state.status = "FAIL";
        });
    }
});

type RejectPayload = { aborted: boolean; message?: string };

export const asyncReqCommentList = createAsyncThunk<
        any, // 성공 시 반환 타입 (API 응답 타입)
        CommentListasyncReqPros, // thunk 파라미터 타입
        {
            rejectValue: RejectPayload; // ❗ rejectWithValue 타입 명시
        }
    >(
    reducerId,
    async ({ page_size, curr_page, board_seq }: CommentListasyncReqPros, thunkAPI) => {
        // 이전 요청이 있으면 취소
        const prevController = controllerMap.get(reducerId);
        if (prevController) prevController.abort();

        // 새 요청용 controller 생성
        const controller = new AbortController();
        controllerMap.set(reducerId, controller);

        try {
            const res = await fetch(`${process.env.REACT_APP_API_DOMAIN}/ApiReact/CommentList.aspx?page_size=${page_size}&curr_page=${curr_page}&board_seq=${encodeURIComponent(board_seq)}`,
                {
                    signal: controller.signal,
                }
            );
            const data = await res.json();
            return data;
        }
        catch (error: any) {
            // ❗ AbortError인 경우는 구분해서 처리
            if (error.name === "AbortError") {
                return thunkAPI.rejectWithValue({ aborted: true });
            }
            return thunkAPI.rejectWithValue({ aborted: false, message: error.message });
        }
    }
);

export const CommentListActions = slice.actions;
export default slice.reducer;